export default __webpack_public_path__ + "images/JP.8096929.png";